import { News } from "./../../../models/News";
import { useState } from "react";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../utils/hooks/useFacility";
import { GET_NEWS } from "../../../api/apiRoutes";

export default function useNews() {
  const facilityIds = useFacility();
  const { get } = useApiRequest();

  const [news, setNews] = useState<News[]>([]);

  const acceptTransaction = async () => {
    const { result, isError } = await get(GET_NEWS(facilityIds));
    if (!isError) {
      setNews(result);
    }
  };

  return {
    acceptTransaction,
    news,
  };
}
